import React from "react";
import CustomModal from "../../../../components/Modal";
import { useForm } from "react-hook-form";
import { AssignContainerFormValues } from "../../../../service/interfaces/Forms";
import { yupResolver } from "@hookform/resolvers/yup";
import { validationSchema } from "../../../../service/validation/assignContainer";
import Input from "../../../../components/FormInputs";
import DatePicker from "../../../../components/Datepicker";
import CustomDropDown from "../../../../components/Dropdown/CustomDropDown";
import FormTitle from "../../../../components/FormTitle";

interface AssignContainerProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const AssignContainer: React.FC<AssignContainerProps> = ({ open, setOpen }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    trigger,
    reset,
    watch,
    control,
    setValue,
  } = useForm<AssignContainerFormValues>({
    resolver: yupResolver(validationSchema) as any,
  });

  const cancel = () => {
    setOpen(false);
  };
  return (
    <div>
      <CustomModal
        isOpen={open}
        title="Assign Container"
        width="900px"
        titleColor="#444FBD"
        onClose={() => setOpen(false)}
        content={
          <div>
            <form
            //   onSubmit={handleSubmit(Submit)}
            >
              <div className="flex flex-row gap-4">
                <div className="flex flex-col gap-4 pt-8 border-r w-full border-dashed border-[#C1C1C1] pr-4">
                  <Input
                    register={register}
                    name="containerNumber"
                    errors={errors}
                    label="Container Number"
                    placeholder="Container Number"
                    type="text"
                    onBlur={() => trigger("containerNumber")}
                  />
                  <CustomDropDown
                    errors={errors}
                    register={register}
                    label="liner"
                    name="liner"
                    options={[]}
                    defaultValue={watch("liner")}
                  />
                  <Input
                    register={register}
                    name="yardLocation"
                    errors={errors}
                    label="Yard Location"
                    placeholder="Yard Location"
                    type="text"
                    onBlur={() => trigger("yardLocation")}
                  />
                  <DatePicker
                    label="Starting Date & Time"
                    onDateChange={(date: string) =>
                      setValue("bookingDateandTime", new Date(date))
                    }
                    register={register("bookingDateandTime")}
                    name="bookingDateandTime"
                    includeTime={true}
                    errors={errors}
                    disabled={false}
                    //   defaultValue={watch("bookingDateandTime")}
                  />
                </div>
                <div className="w-full mt-2">
                  <FormTitle title="Container Check List" />
                  <div className="overflow-auto">
                    <div className="grid grid-cols-3 gap-4 font-semibold text-sm text-gray-700 mb-2">
                      <div>Condition</div>
                      <div>Remarks</div>
                      <div>Condition</div>
                    </div>
                    {[
                      "Size - 20” Ft",
                      "Type - Closed",
                      "Interior - Wooden",
                      "Floor - Wooden",
                      "Temp - 20” Ft",
                      "Exterior - 20” Ft",
                    ].map((label, index) => (
                      <div
                        className="grid grid-cols-3 gap-4 items-center mb-2"
                        key={index}
                      >
                        <div className="flex items-center gap-2">
                          <input
                            type="checkbox"
                            className="form-checkbox h-4 w-4 text-[#444FBD] rounded border-gray-300 focus:ring-[#444FBD]"
                            {...register(
                              `containerCheckList.${index}.checked` as const
                            )}
                          />
                          <input
                            type="text"
                            value={label}
                            readOnly
                            className="text-sm w-full bg-transparent focus:outline-none"
                          />
                        </div>
                        <input
                          type="text"
                          className="border border-gray-300 rounded px-2 py-1 text-sm w-full focus:outline-[#444FBD]"
                          placeholder="Remarks"
                          {...register(
                            `containerCheckList.${index}.remarks` as const
                          )}
                        />
                        <select
                          className="border border-gray-300 rounded px-2 py-1 text-sm w-full focus:outline-[#444FBD]"
                          {...register(
                            `containerCheckList.${index}.condition` as const
                          )}
                        >
                          <option value="">Select</option>
                          <option value="Yes">Yes</option>
                          <option value="No">No</option>
                          <option value="Half ok">Half ok</option>
                        </select>
                      </div>
                    ))}
                    <Input
                      label=""
                      name={`note`}
                      errors={errors}
                      placeholder="Enter Note"
                      register={register}
                      multiline
                      rows={2}
                    />
                  </div>
                </div>
              </div>
              <div className="flex gap-4 justify-end mt-4">
                <button
                  type="button"
                  onClick={cancel}
                  className="w-36 h-10 rounded-lg text-[#444FBD] border border-[#444FBD] hover:border-gray-400 transition duration-200"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  //   onClick={handleSubmit(Submit)}
                  className="w-36 h-10 rounded-lg bg-[#444FBD] text-white transition duration-200"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        }
      />
    </div>
  );
};

export default AssignContainer;
